import {Injectable} from '@angular/core';
import {AbstractControl, FormGroup, ValidationErrors} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SharedFormService {

  constructor() {
  }

  setValidator(formGroup: FormGroup, controlName: string, validators: ((control: AbstractControl) => (ValidationErrors | null))[]) {
    formGroup.get(controlName).setValidators(validators);
    formGroup.get(controlName).updateValueAndValidity();
  }

  clearValidator(formGroup: FormGroup, controlName: string) {
    formGroup.get(controlName).clearValidators();
    formGroup.get(controlName).updateValueAndValidity();
  }

}
